/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ConnectZaloPage = lazyLoad(
  () => import('./index'),
  module => module.ConnectZaloPage
);
